/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VoxtralTestCorrectionRequest } from '../../models/voxtral-test-correction-request';

export interface ApiBroadcastVoxtralTestCorrectionPost$Params {
      body?: VoxtralTestCorrectionRequest
}

export function apiBroadcastVoxtralTestCorrectionPost(http: HttpClient, rootUrl: string, params?: ApiBroadcastVoxtralTestCorrectionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralTestCorrectionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralTestCorrectionPost.PATH = '/api/Broadcast/voxtral-test-correction';
